/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Evidence,
    EvidenceFromJSON,
    EvidenceFromJSONTyped,
    EvidenceToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface EvidenceResponse
 */
export interface EvidenceResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof EvidenceResponse
     */
    msg: string;
    /**
     * 
     * @type {Evidence}
     * @memberof EvidenceResponse
     */
    entry: Evidence;
}

export function EvidenceResponseFromJSON(json: any): EvidenceResponse {
    return EvidenceResponseFromJSONTyped(json, false);
}

export function EvidenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': EvidenceFromJSON(json['entry']),
    };
}

export function EvidenceResponseToJSON(value?: EvidenceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': EvidenceToJSON(value.entry),
    };
}


